import React, { useState } from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  Button, Paper, TableContainer, Box,
  Typography, useTheme, IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import { FaRegEye } from "react-icons/fa6";
import { useNavigate, useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';

const StyledTableCell = styled(TableCell)(() => ({
  border: '1px solid #ccc',
  fontWeight: 400,
  padding: '10px 10px 10px 15px',
  fontSize: "14px",
  textAlign: "center",
  color: "#000000",
  backgroundColor: "#fff",
  whiteSpace: "nowrap"
}));



const StyledTableBody = styled(TableCell)(() => ({
  fontWeight: 400,
  fontSize: "14px",
  color: '#37352F',
  padding: "12px 12px 12px 15px",
  backgroundColor: "#fff",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
}));



const QuantityList = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [pageNumber, setPageNumber] = useState(1)
  const rowsPerPage = 10
  const totalPages = 1

  

  const [tableData, setTableData] = useState([
    {
      reportingDate: "2024-07-10",
      reportedBy: "Sanjeev Lodhi",
      activityCount: 5,
      submittedOn: "2024-07-11",
    },
    {
      reportingDate: "2024-07-12",
      reportedBy: "Amit Sharma",
      activityCount: 3,
      submittedOn: "2024-07-13",
    }
  ]);
  
  const startIndex = (pageNumber - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = tableData.slice(startIndex, endIndex);


  const handleCreateNewDpr = () => {

    navigate(`/projects/${projectId}/new_dpr/create-new-dpr`);
  };

  return (
    <Box sx={{ mt: 6, width: "100%" }}>
      {/* <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>
        Quantity Dpr
      </Typography> */}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "20px" }}>
        <Button
          sx={{
            border: '1px solid #25252517',
            p: "6px 16px",
            backgroundColor: theme?.customSettings?.themeColor || "#1976d2",
            color: "#fff"
          }}
          onClick={handleCreateNewDpr}
        >
          Create New DPR
        </Button>
      </Box>

      <Box sx={{ width: '100%', overflowX: 'auto' }}>
        <Paper elevation={2} sx={{ mt: "40px", border: '1px solid #E9E9E7', borderRadius: '4px' }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Reporting Date</StyledTableCell>
                  <StyledTableCell>Reported By</StyledTableCell>
                  <StyledTableCell>Activity Count</StyledTableCell>
                  <StyledTableCell>Submitted On</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentRows.length === 0 ? (
                  <TableRow>
                    <StyledTableBody colSpan={5}>No data available</StyledTableBody>
                  </TableRow>
                ) : (
                  currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <StyledTableBody>{dayjs(row.reportingDate).format("DD-MM-YYYY")}</StyledTableBody>
                      <StyledTableBody>{row.reportedBy}</StyledTableBody>
                      <StyledTableBody>{row.activityCount}</StyledTableBody>
                      <StyledTableBody>{dayjs(row.submittedOn).format("DD-MM-YYYY")}</StyledTableBody>
                      <StyledTableBody>
                        <IconButton >
                          <FaRegEye />
                        </IconButton>
                      </StyledTableBody>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, pr: 2 }}>
        <PaginationComponent
          pageNumber={pageNumber}
          totalPages={totalPages || 1}
          onPageChange={setPageNumber}
        />
      </Box>
    </Box>
  );
};

export default QuantityList;